import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/ui/dialog";
import type { StockResponseDTO } from "../types/stock.types";
import { memo } from "react";

interface StockImageDialogProps {
  open: boolean;
  stock: StockResponseDTO | null;
  onClose: () => void;
}

export const StockImageDialog = memo(function StockImageDialog({
  open,
  stock,
  onClose,
}: StockImageDialogProps) {
  if (!stock || !stock.photoUrl) return null;

  return (
    <Dialog open={open} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>
            {stock.productName} - {stock.barcode}
          </DialogTitle>
        </DialogHeader>
        <div className="flex justify-center">
          <img
            src={`${stock.photoUrl}?t=${new Date(stock.updatedAt).getTime()}`}
            alt={stock.productName}
            className="max-w-full max-h-[70vh] object-contain rounded-md"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
});
